import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "input"]
  static values = { optional: Boolean }
  
  syncFromPicker() {
    if (this.hasInputTarget && this.hasPickerTarget) {
      // For optional fields, clear the input if the default color is selected
      if (this.optionalValue && this.pickerTarget.value === '#000000' && !this.inputTarget.dataset.hasUserSelection) {
        this.inputTarget.value = ''
      } else {
        this.inputTarget.value = this.pickerTarget.value
        this.inputTarget.dataset.hasUserSelection = 'true'
      }
      // Dispatch input event to trigger other controllers
      this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }
  
  syncFromInput() {
    if (this.hasInputTarget && this.hasPickerTarget) {
      // If input is empty, set picker to a default but don't update the input
      if (this.inputTarget.value === '') {
        this.pickerTarget.value = '#000000'
        delete this.inputTarget.dataset.hasUserSelection
      } else {
        this.pickerTarget.value = this.inputTarget.value
        this.inputTarget.dataset.hasUserSelection = 'true'
      }
    }
  }
}